<div class="layout-column custom-panel full-width full-height">

  <div class="flex layout-column padding-10 padding-top-20">
    <app-branches-multi-select [selectedIds]="filtersCopy.branchIds"
                               [options]="visitPlan.branchReferences"
                               (onChange)="onBranchesSelect($event.branchIds)">
    </app-branches-multi-select>

    <app-demand-accounts-multi-select
      class="margin-top-20"
      [branchIds]="filtersCopy.branchIds.length ? filtersCopy.branchIds : visitPlan.branchIds"
      [selectedIds]="filtersCopy.accountIds"
      (onChange)="onDemandAccountsSelect($event.accountIds)">

    </app-demand-accounts-multi-select>

    <app-bringoz-select class="margin-top-5"
                        [options]="inRouteOptions"
                        [selectedValue]="routedFilter.value"
                        [bindValue]="'value'"
                        [bindLabel]="'label'"
                        [placeholder]="'Job Status'"
                        (onValueChange)="onChangeRoutedFilter($event)">
    </app-bringoz-select>

  </div>

  <hr class="main-divider">

  <div class="layout-row layout-align-start-center padding-5">
    <bringoz-button [type]="'outline'"
                    [theme]="'primary'"
                    (onClick)="onReset();$event.stopPropagation();">
      <span>{{ 'Reset' | translate }}</span>
    </bringoz-button>
    <span class="flex"></span>
    <bringoz-button [type]="'tertiary'"
                    [theme]="'primary'"
                    (onClick)="onCancel();$event.stopPropagation();">
      <span>{{ 'Cancel' | translate }}</span>
    </bringoz-button>


    <bringoz-button [theme]="'secondary'"
                    (onClick)="onSubmit();$event.stopPropagation();">
      <span>{{ 'Submit' | translate }}</span>
    </bringoz-button>
  </div>

</div>
